import { styled, TextField } from "@mui/material";

export const StyledTextField = styled(TextField)`
  .MuiInputBase-root {
    height: 2.286rem;
    border: 1px solid ${(props) => props.theme.wsc.palette.neutral[500]};
    border-radius: ${(props) => props.theme.wsc.radius.m};
    background-color: ${(props) => props.theme.wsc.palette.neutral[700]};

    &::before,
    &::after {
      content: none;
    }

    &:not(.Mui-disabled):not(.Mui-error):has(input:not(:placeholder-shown)) {
      border-color: ${(props) => props.theme.wsc.palette.neutral[600]};
      background-color: ${(props) => props.theme.wsc.palette.neutral[700]};
    }

    &:not(.Mui-disabled):not(.Mui-error):hover,
    &:has(input:not(:placeholder-shown)):not(.Mui-disabled):not(
        .Mui-error
      ):hover {
      border-color: ${(props) => props.theme.wsc.palette.neutral[600]};
      background-color: ${(props) => props.theme.wsc.palette.neutral[600]};
    }

    &:not(.Mui-disabled):not(.Mui-error):focus,
    &:not(.Mui-disabled):not(.Mui-error).Mui-focused {
      background-color: ${(props) => props.theme.wsc.palette.neutral[500]};
    }

    &:has(input:not(:placeholder-shown)):not(.Mui-disabled):not(
        .Mui-error
      ):focus,
    &:not(.Mui-disabled):not(.Mui-error).Mui-focused:has(
        input:not(:placeholder-shown)
      ) {
      background-color: ${(props) => props.theme.wsc.palette.neutral[700]};
    }

    &:not(.Mui-disabled):not(.Mui-error):focus,
    &:not(.Mui-disabled):not(.Mui-error).Mui-focused,
    &:has(input:not(:placeholder-shown)):not(.Mui-disabled):not(
        .Mui-error
      ):focus,
    &:not(.Mui-disabled):not(.Mui-error).Mui-focused:has(
        input:not(:placeholder-shown)
      ) {
      border-color: ${(props) => props.theme.wsc.palette.neutral[0]};

      & input.MuiInputBase-input {
        &::placeholder,
        &::-ms-input-placeholder {
          color: ${(props) => props.theme.wsc.palette.neutral[200]};
        }
      }
    }

    &.Mui-disabled {
      border-color: ${(props) => props.theme.wsc.palette.neutral[500]};
      background-color: ${(props) => props.theme.wsc.palette.neutral[800]};
    }

    & input.MuiInputBase-input {
      padding: ${(props) => props.theme.wsc.spacing[1]};
      ${(props) => props.theme.wsc.typography.body1};
      color: ${(props) => props.theme.wsc.palette.neutral[100]};

      &::placeholder,
      &::-ms-input-placeholder {
        color: ${(props) => props.theme.wsc.palette.neutral[200]};
        opacity: 1;
      }

      &.Mui-disabled {
        color: ${(props) => props.theme.wsc.palette.neutral[300]};
        -webkit-text-fill-color: unset;

        &::placeholder,
        &::-ms-input-placeholder {
          color: ${(props) => props.theme.wsc.palette.neutral[300]};
        }
      }
    }

    &.Mui-error {
      border-color: ${(props) => props.theme.wsc.palette.warning[300]};
    }
  }
`;
